import Rails from '@rails/ujs';

// Ensure this isn't started twice when we import it in both the application entrypoint
// and one of the widget entrypoints on the preview page.
if (!window.hasRailsUjsStarted) {
  Rails.start();
  window.hasRailsUjsStarted = true;
}
